const FEATURE_HELP_URLS = {
  agent_bots: 'https://talkvia.com.br/hc/agent-bots',
  agents: 'https://talkvia.com.br/hc/agents',
  ai_agent: '/hc/user-guide/pt-BR/primeira-agente-ia',
  audit_logs: 'https://talkvia.com.br/hc/audit-logs',
  campaigns: 'https://talkvia.com.br/hc/campaigns',
  canned_responses: 'https://talkvia.com.br/hc/canned',
  channel_email: 'https://talkvia.com.br/hc/email',
  channel_facebook: 'https://talkvia.com.br/hc/fb',
  custom_attributes: 'https://talkvia.com.br/hc/custom-attributes',
  dashboard_apps: 'https://talkvia.com.br/hc/dashboard-apps',
  help_center: 'https://talkvia.com.br/hc/help-center',
  inboxes: '/hc/user-guide/pt-BR/conexoes',
  integrations: '/hc/user-guide/pt-BR/integracoes-externas',
  labels: 'https://talkvia.com.br/hc/labels',
  macros: 'https://talkvia.com.br/hc/macros',
  reports: 'https://talkvia.com.br/hc/reports',
  sla: 'https://talkvia.com.br/hc/sla',
  team_management: 'https://talkvia.com.br/hc/teams',
  webhook: 'https://talkvia.com.br/hc/webhooks',
  billing: 'https://talkvia.com.br/pricing',
  saml: 'https://talkvia.com.br/hc/saml',
  captain_billing: 'https://talkvia.com.br/hc/captain_billing',
};

const TALKVIA_LOCALIZED_HELP_URLS = {
  ai_agent: {
    en: '/hc/user-guide/en/first-ai-agent',
    default: '/hc/user-guide/pt-BR/primeira-agente-ia',
  },
  inboxes: {
    en: '/hc/user-guide/en/connections',
    default: '/hc/user-guide/pt-BR/conexoes',
  },
  integrations: {
    en: '/hc/user-guide/en/integrations',
    default: '/hc/user-guide/pt-BR/integracoes-externas',
  },
};

const localizedTalkviaHelpUrl = featureName => {
  const urls = TALKVIA_LOCALIZED_HELP_URLS[featureName];
  if (!urls) return null;

  const selectedLocale = window.chatwootConfig?.selectedLocale || '';
  return selectedLocale.toLowerCase().startsWith('en') ? urls.en : urls.default;
};

export function getHelpUrlForFeature(featureName) {
  return localizedTalkviaHelpUrl(featureName) || FEATURE_HELP_URLS[featureName];
}
